import { ActionReducer, ActionReducerMap, createFeatureSelector, createSelector, MetaReducer } from '@ngrx/store';
import { RouterStateUrl } from '../../models/router-state-url';
import { ENV_CONVENTION } from '../../utils/constants';

import * as fromRouter from '@ngrx/router-store';
import * as fromLayout from './layout.reducer';
import * as fromSpreading from './spreading.reducer';

/**
 * Every reducer module's default export is the reducer function itself. In
 * addition, each module should export a type or interface that describes
 * the state of the reducer plus any selector functions. The `* as`
 * notation packages up all of the exports into a single object.
 */

/**
 * As mentioned, we treat each reducer like a table in a database. This means
 * our top level state interface is just a map of keys to inner state types.
 */
export interface State {
  layout: fromLayout.State;
  router: fromRouter.RouterReducerState<RouterStateUrl>;
  spreading: fromSpreading.State;
}

/**
 * Our state is composed of a map of action reducer functions.
 * These reducer functions are called with each dispatched action
 * and the current or initial state and return a new immutable state.
 */
export const reducers: ActionReducerMap<State> = {
  layout: fromLayout.reducer,
  router: fromRouter.routerReducer,
  spreading: fromSpreading.reducer,
};

// console.log all actions
export function logger(reducer: ActionReducer<State>): ActionReducer<State> {
  return function (state: State, action: any): State {
    // console.log('state', state);
    // console.log('action', action);

    return reducer(state, action);
  };
}

/**
 * By default, @ngrx/store uses combineReducers with the reducer map to compose
 * the root meta-reducer. To add more meta-reducers, provide an array of meta-reducers
 * that will be composed to form the root meta-reducer.
 */
export const isNonProdHost = (): boolean =>
  window.location.hostname.toLowerCase() !== ENV_CONVENTION.PROD_HOST_MARKER;

export const metaReducers: MetaReducer<State>[] = isNonProdHost()
  ? [logger]
  : [];

/**
 * Reducers
 */
export const getSpreadingState = createFeatureSelector<fromSpreading.State>('spreading');

export const getSpreadingDraggingState = createSelector(
  getSpreadingState,
  fromSpreading.getDraggingState,
);
